import React, { Component } from 'react'
import {
  ResponsiveContainer,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Radar,
  Text,
  Tooltip,
  Legend
} from 'recharts'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import './styles.scss'

export default class RadarChartRecharts extends Component {
  render() {
    const data = [
      { category: 'Gesundheit', frauen: 49, männer: 40, fullMark: 50 },
      { category: 'Soziale Fragen', frauen: 21, männer: 12, fullMark: 50 },
      {
        category: 'Arbeit',
        frauen: 12,
        männer: 20,
        fullMark: 50
      },
      { category: 'Finanzen', frauen: 14, männer: 20, fullMark: 50 },
      { category: 'Wirtschaft', frauen: 30, männer: 39, fullMark: 50 },
      { category: 'Staatspolitik', frauen: 15, männer: 21, fullMark: 50 },
      { category: 'Verkehr', frauen: 15, männer: 12, fullMark: 50 },
      { category: 'Umwelt', frauen: 35, männer: 21, fullMark: 50 },
      {
        category: 'Landwirtsch.',
        frauen: 13,
        männer: 10,
        fullMark: 50
      },
    ]

    const degrees_to_radians = degrees => {
      var pi = Math.PI
      return degrees * (pi / 180)
    }

    const customizedTick = props => {
      const { payload, textAnchor, radius } = props
      const { coordinate, value } = payload
      const labelRadius = radius + (browserCheck.isMobile || browserCheck.isTablet ? 12 : 20)
      const labelAngle = degrees_to_radians(180 - coordinate)
      const dx = props.cx - labelRadius * Math.cos(labelAngle),
        dy = props.cy - labelRadius * Math.sin(labelAngle)
      return (
          <text
            className='recharts-text recharts-polar-angle-axis-tick-value'
            textAnchor={textAnchor}
          >
            <tspan x={dx} y={dy} >
              {value}
            </tspan>
          </text>
      )
    }


    return (
      <ResponsiveContainer width='100%' height='100%'>
        <RadarChart data={data} cx='50%' cy='52%' outerRadius={browserCheck.isMobile || browserCheck.isTablet ? '89%' : '87%'}>
          <PolarGrid gridType='circle' />
          {/* <Legend verticalAlign='top' height={100}/> */}
          <PolarAngleAxis
            dataKey='category'
            tick={customizedTick}
            // tick={{ fontSize: 16, transform: 'translate(0, 2)' }}
          />
          <PolarRadiusAxis
            axisLine={false}
            angle={90}
            domain={[0, 50]}
            tickCount={6}
            orientation={'right'}
            tick={{ fontSize: (browserCheck.isMobile || browserCheck.isTablet ? 10 : 11), transform: 'translate(4, 4)' }}
          />
          <Radar
            name='Frauen'
            dataKey='frauen'
            stroke='#A757A3'
            fill='#A757A3'
            fillOpacity={0.3}
          />
          <Radar
            name='Männer'
            dataKey='männer'
            stroke='#9698A8'
            fill='#9698A8'
            fillOpacity={0.3}
          />
          
          <Tooltip
            formatter={(value) => {
              return `${value}%`
            }}
          />
        </RadarChart>
      </ResponsiveContainer>
    )
  }
}
